module.exports = __webpack_public_path__ + "static/scale-model-of-madison-wisconsin-4e84706d6b56aa639ab4f0ce904487d9.png";